import { render, staticRenderFns } from "./ColorBall.vue?vue&type=template&id=46fe7aae&scoped=true"
import script from "./ColorBall.vue?vue&type=script&lang=js"
export * from "./ColorBall.vue?vue&type=script&lang=js"
import style0 from "./ColorBall.vue?vue&type=style&index=0&id=46fe7aae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fe7aae",
  null
  
)

export default component.exports